import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';

@Component({
  selector: 'fdk-dialog-actions',
  templateUrl: './dialog-actions.component.html',
  styleUrl: './dialog-actions.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkDialogActionsComponent {}
